/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createSupportCase} from '../api'

export const useMutationCreateSupportCase = createReactQueryMutationHook('createSupportCase', createSupportCase)
